/**
 * 应用主要路由配置
 */

import type { RouteRecordRaw } from 'vue-router';

// 组件懒加载 - 使用重构后的版本
const TextToAudio = () => import(/* webpackChunkName: "main" */ '@/views/textToAudio/TextToAudio.vue');

// 转换记录页面
const ConversionRecords = () => import(/* webpackChunkName: "tasks" */ '@/views/ConversionRecords.vue');

// 其他页面
const BatchProcess = () => import(/* webpackChunkName: "batch" */ '@/views/batch/BatchTaskPageNew.vue');

const Library = () => import(/* webpackChunkName: "library" */ '@/views/Library.vue');
const Documents = () => import(/* webpackChunkName: "documents" */ '@/views/Documents.vue');
const Settings = () => import(/* webpackChunkName: "settings" */ '@/views/Settings.vue');
const PaymentResult = () => import(/* webpackChunkName: "payment" */ '@/views/PaymentResult.vue');

// 推广中心相关页面
const ReferralCenter = () => import(/* webpackChunkName: "referral" */ '@/views/referral/ReferralCenter.vue');
const ReferralLanding = () => import(/* webpackChunkName: "referral" */ '@/views/referral/ReferralLanding.vue');
const ReferralDashboard = () => import(/* webpackChunkName: "referral" */ '@/views/referral/ReferralDashboard.vue');

// 应用主要路由
export const appRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'main',
    component: TextToAudio,
    meta: {
      title: '文本转语音',
      icon: 'Microphone',
      keepAlive: true,
      showIcp: true  // 首页显示备案号
    }
  },
  {
    path: '/tasks',
    name: 'tasks',
    component: ConversionRecords,
    meta: {
      title: '转换记录',
      icon: 'List',
      keepAlive: true,
      showIcp: false  // 工作台页面不显示备案号
    }
  },

  {
    path: '/batch',
    name: 'batch',
    component: BatchProcess,
    meta: {
      title: '批量转换',
      icon: 'Files',
      requiresAuth: true,
      keepAlive: true,
      showIcp: false  // 工作台页面不显示备案号
    }
  },

  {
    path: '/library',
    name: 'library',
    component: Library,
    meta: {
      title: '资产库',
      icon: 'FolderOpened',
      requiresAuth: true,
      keepAlive: true,
      showIcp: false  // 工作台页面不显示备案号
    }
  },
  {
    path: '/referral',
    component: ReferralCenter,
    meta: {
      title: '推广中心',
      icon: 'Promotion',
      showIcp: false
    },
    children: [
      {
        path: '',
        name: 'referral-landing',
        component: ReferralLanding,
        meta: {
          title: '推广中心 - 落地页'
        }
      },
      {
        path: 'dashboard',
        name: 'referral-dashboard',
        component: ReferralDashboard,
        meta: {
          title: '推广中心 - 数据中心',
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/docs',
    name: 'docs',
    component: Documents,
    meta: {
      title: '文档',
      icon: 'Document',
      keepAlive: true,
      showIcp: false  // 工作台页面不显示备案号
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: {
      title: '系统设置',
      icon: 'Setting',
      requiresAuth: true,
      keepAlive: true,
      showIcp: false  // 工作台页面不显示备案号
    }
  },
  {
    path: '/payment/result',
    name: 'PaymentResult',
    component: PaymentResult,
    meta: {
      title: '支付结果',
      icon: 'CreditCard',
      requiresAuth: true,
      hideInMenu: true,
      showIcp: false  // 工作台页面不显示备案号
    }
  },
  // 重定向路由
  {
    path: '/auth/login',
    redirect: '/'
  },
  {
    path: '/auth/register',
    redirect: '/'
  },

  // 404页面
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: '页面未找到',
      hideInMenu: true,
      showIcp: false  // 错误页面不显示备案号
    }
  }
];
